import {
  cilAppsSettings,
  cilBell,
  cilInfo,
  cilMoon,
  cilPlus,
  cilSettings,
  cilUser,
} from '@coreui/icons'
import CIcon from '@coreui/icons-react'
import {
  CButton,
  CCard,
  CCardBody,
  CCardHeader,
  CCol,
  CNav,
  CNavLink,
  CRow,
  CWidgetStatsF,
  CAvatar,
  CDropdown,
  CDropdownToggle,
  CDropdownMenu,
  CDropdownItem,
  CDropdownDivider,
  CBadge,
  CSmartTable,
  CHeaderNav,
  CButtonGroup,
} from '@coreui/react-pro'
import { cilPeople } from '@coreui/icons'
import React, { useEffect, useState } from 'react'
import CommonService from 'src/service/CommonService'
import GameStatusModal from './GameStatusModal'
import TransferAdminModal from './TransferAdminModal'
import ToastComponent from 'src/components/common/TaostComponent'
import { Link, useNavigate } from 'react-router-dom'
import PageInfoModal from 'src/components/PageInfoModal'
import AdminUserList from './AdminUserList'
import './GameAccount.css'

const GameAccount = (props) => {
  const [visible, setVisible] = useState(false)
  const [openActionsId, setOpenActionsId] = useState(null)
  const [defaultActive, setDefaultActive] = useState(true)
  const [runningActive, setRunningActive] = useState(false)
  const [completedActive, setCompletedActive] = useState(false)
  const [activePage, setActivePage] = useState(1)
  const [columnFilter, setColumnFilter] = useState([])
  const [columnSorter, setColumnSorter] = useState(null)
  const [itemsPerPage, setItemsPerPage] = useState(10)
  const [users, setUsers] = useState()
  const [dashboardData, setDashboardData] = useState()
  const adminDetails = JSON.parse(localStorage.getItem('admin'))
  const columns = [
    {
      label: <CIcon icon={cilPeople} />,
      key: 'logo',
      filter: false,
      sorter: false,
    },
    { label: 'Game', key: 'game_name', sorter: true },
    { label: 'Setup', key: 'admin', filter: false, sorter: false },
    {
      key: 'show_details',
      label: 'Actions',
      filter: false,
      sorter: false,
    },
  ]
  const getBadge = (status) => {
    switch (status) {
      case 1:
        return 'success'
      case 2:
        return 'warning'
      case 3:
        return 'danger'
      default:
        return 'primary'
    }
  }

  const handleDefaultActive = () => {
    // getUsers()
    setDefaultActive(true)
    setCompletedActive(false)
    setRunningActive(false)
  }
  const handleCompleteActive = () => {
    // getUsers()
    setCompletedActive(true)
    setRunningActive(false)
    setDefaultActive(false)
  }

  const handleRunningActive = () => {
    // getUsers()
    setRunningActive(true)
    setCompletedActive(false)
    setDefaultActive(false)
  }
  const [loading, setLoading] = useState()
  const [gameStatus, setGameStatus] = useState()
  useEffect(() => {
    setLoading(true)
    const offset = itemsPerPage * activePage - itemsPerPage
    let params = new URLSearchParams()
    Object.keys(columnFilter).forEach((key) => {
      params.append(key, columnFilter[key])
    })
    columnSorter &&
      columnSorter.column !== undefined &&
      params.append('sort', `${columnSorter.column}%${columnSorter.state}`)
    const gameType = {}
    gameType.running = runningActive
    gameType.completed = completedActive
    CommonService.gameAccount(
      offset,
      itemsPerPage,
      activePage,
      params,
      runningActive,
      completedActive,
    ).then((result) => {
      setUsers(result.data)
      setDashboardData(result.new_data)
      setLoading(false)
    })
  }, [activePage, columnFilter, columnSorter, itemsPerPage, runningActive, completedActive])

  const [userId, setUserId] = useState()
  const handleGameStatus = (status, userId) => {
    setVisible(true)
    setGameStatus(status)
    setUserId(userId)
  }

  const [transferVisible, setTransferVisible] = useState(false)

  const navigate = useNavigate()
  const gameLogin = (userId, gameId) => {
    const data = {}
    data.userId = userId
    data.gameId = gameId
    localStorage.setItem('gameId', gameId)
    CommonService.gameLogin(data).then((res) => {
      if (res.status === 200) {
        localStorage.setItem('admin', JSON.stringify(res.user))
        localStorage.setItem('token', JSON.stringify(res.token))
        navigate('/dashboard')
      }
    })
  }
  const getStarted = (userId, gameId) => {
    const data = {}
    data.userId = userId
    data.gameId = gameId
    localStorage.setItem('gameId', gameId)
    CommonService.gameLogin(data).then((res) => {
      if (res.status === 200) {
        localStorage.setItem('admin', JSON.stringify(res.user))
        localStorage.setItem('token', JSON.stringify(res.token))
        navigate('/get-started')
      }
    })
  }

  const enterGameAdmin = (userId, gameId, url) => {
    const data = {}
    data.userId = userId
    data.gameId = gameId
    localStorage.setItem('gameId', gameId)
    CommonService.gameLogin(data)
      .then((res) => {
        if (res.status === 200) {
          localStorage.setItem('admin', JSON.stringify(res.user))
          localStorage.setItem('token', JSON.stringify(res.token))
          navigate(url)
        }
      })
      .catch((e) => {
        ToastComponent(e.response?.data?.message, 'error')
      })
  }

  const redirectToURL = () => {
    navigate('/season-register')
  }

  const setGameId = (gameId) => {
    localStorage.setItem('gameId', gameId)
    navigate('/activate-game')
  }

  const [infoPageModal, setInfoPageModal] = useState(false)
  const [infoText] = useState('')

  return (
    <>
      {adminDetails?.user_role_id !== 1 && (
        <>
          <CRow className="game-dashboard">
            <CCol xs={12} sm={6} lg={3}>
              <CWidgetStatsF
                className="mb-3 widget"
                icon={<CIcon width={24} icon={cilSettings} size="xl" />}
                title="All Games"
                value={dashboardData?.all_games}
                color="primary-gradient"
              />
            </CCol>
            <CCol xs={12} sm={6} lg={3}>
              <CWidgetStatsF
                className="mb-3 widget"
                icon={<CIcon width={24} icon={cilUser} size="xl" />}
                title="Completed Games"
                value={dashboardData?.complete_games}
                color="info-gradient"
              />
            </CCol>
            <CCol xs={12} sm={6} lg={3}>
              <CWidgetStatsF
                className="mb-3 widget"
                icon={<CIcon width={24} icon={cilMoon} size="xl" />}
                title="All Players"
                value={dashboardData?.all_players}
                color="warning-gradient"
              />
            </CCol>
            <CCol xs={12} sm={6} lg={3}>
              <CWidgetStatsF
                className="mb-3 widget"
                icon={<CIcon width={24} icon={cilBell} size="xl" />}
                title="All Members"
                value={dashboardData?.all_members}
                color="danger-gradient"
              />
            </CCol>
          </CRow>

          <CRow>
            <CCol xs={12} sm={12} lg={12}>
              <CCard className="game-card">
                <CCardHeader className="card-header">
                  <strong>Games</strong>
                  <CHeaderNav className="float-end">
                    <CButtonGroup aria-label="Theme switch">
                      <CButton
                        color="success"
                        onClick={redirectToURL}
                        title="Start New Game"
                        className="start-game-btn"
                      >
                        <CIcon icon={cilPlus} />
                      </CButton>
                      <CDropdown variant="btn-group">
                        <CDropdownToggle color="danger" title="Tools">
                          <CIcon icon={cilSettings} />
                        </CDropdownToggle>
                        <CDropdownMenu>
                          <CDropdownItem href="/duplicate-game">Duplicate Game</CDropdownItem>
                          <CDropdownItem href="/copy-players">Copy Players</CDropdownItem>
                          <CDropdownItem href="/copy-branding">Copy Branding</CDropdownItem>
                          <CDropdownItem href="/copy-sponsors">Copy Sponsor</CDropdownItem>
                        </CDropdownMenu>
                      </CDropdown>
                    </CButtonGroup>
                  </CHeaderNav>
                </CCardHeader>
                <CCardBody>
                  <CNav component="nav" variant="pills" className="game-nav">
                    <CNavLink href="#" active={defaultActive} onClick={handleDefaultActive}>
                      All
                    </CNavLink>
                    <CNavLink href="#" active={runningActive} onClick={handleRunningActive}>
                      Active
                    </CNavLink>
                    <CNavLink href="#" active={completedActive} onClick={handleCompleteActive}>
                      Completed
                    </CNavLink>
                  </CNav>

                  <CSmartTable
                    className="game-table"
                    columns={columns}
                    columnFilter={{ external: true }}
                    columnSorter={{ external: true }}
                    scopedColumns={{
                      logo: (item) => (
                        <td>
                          <CAvatar
                            size="md"
                            src={`${process.env.REACT_APP_API_URL}uploads/game_logo/${item.logo}`}
                          />
                        </td>
                      ),
                      game_name: (item) => (
                        <td>
                          <div>
                            <Link onClick={() => gameLogin(item.club_id, item.id)}>
                              {item.game_name}
                            </Link>
                          </div>
                          <div className="small text-medium-emphasis text-nowrap">
                            <span>
                              <CBadge color={getBadge(item.status)}>
                                {item.status === 1 ? 'In-Progress' : 'Completed'}
                              </CBadge>
                              &nbsp;
                              <CBadge color="success">{item.game_type === 1 && 'Club'}</CBadge>
                              <CBadge color="warning">{item.game_type === 2 && 'League'}</CBadge>
                              <CBadge color="primary">{item.game_type === 3 && 'Indoor'}</CBadge>
                              <CBadge color="danger">{item.game_type === 4 && 'Match'}</CBadge>
                            </span>
                          </div>
                        </td>
                      ),
                      admin: (item) => (
                        <td>
                          <CButton
                            color="warning"
                            onClick={() => getStarted(item.club_id, item.id)}
                            title="Get Started"
                            className="get-started-btn"
                          >
                            <CIcon icon={cilInfo} />
                          </CButton>
                        </td>
                      ),
                      show_details: (item) => (
                        <td
                          className={`dropdown-cell${
                            openActionsId === item.id ? ' dropdown-open' : ''
                          }`}
                        >
                          <CDropdown
                            alignment="end"
                            placement="bottom-end"
                            portal
                            onShow={() => setOpenActionsId(item.id)}
                            onHide={() =>
                              setOpenActionsId((current) => (current === item.id ? null : current))
                            }
                          >
                            <CButton color="success">
                              <CIcon icon={cilAppsSettings} />
                            </CButton>
                            <CDropdownToggle color="success" split />
                            <CDropdownMenu className="game-actions-menu">
                              <CDropdownItem href="/duplicate-game">Duplicate Game</CDropdownItem>
                              <CDropdownItem onClick={() => setGameId(item.id)}>
                                Activate Game
                              </CDropdownItem>
                              <CDropdownItem
                                onClick={() => enterGameAdmin(item.club_id, item.id, '/game-info')}
                              >
                                Game Info
                              </CDropdownItem>
                              <CDropdownItem
                                onClick={() => enterGameAdmin(item.club_id, item.id, '/spots')}
                              >
                                Game Spots
                              </CDropdownItem>
                              <CDropdownItem onClick={() => handleGameStatus(item.status, item.id)}>
                                Game Status
                              </CDropdownItem>
                              <CDropdownItem
                                onClick={() =>
                                  enterGameAdmin(item.club_id, item.id, '/game-structure')
                                }
                              >
                                Game Structure
                              </CDropdownItem>
                              <CDropdownItem
                                onClick={() =>
                                  enterGameAdmin(item.club_id, item.id, '/manage-scores')
                                }
                              >
                                Manage Scores
                              </CDropdownItem>
                              <CDropdownItem
                                onClick={() => enterGameAdmin(item.club_id, item.id, '/members')}
                              >
                                Members List
                              </CDropdownItem>
                              <CDropdownItem
                                onClick={() => enterGameAdmin(item.club_id, item.id, '/players')}
                              >
                                Players List
                              </CDropdownItem>
                              <CDropdownItem
                                onClick={() =>
                                  enterGameAdmin(item.club_id, item.id, '/point-system')
                                }
                              >
                                Point System
                              </CDropdownItem>
                              <CDropdownItem href="/plan">Pricing Plan</CDropdownItem>
                              <CDropdownItem
                                onClick={() => enterGameAdmin(item.club_id, item.id, '/rounds')}
                              >
                                Rounds
                              </CDropdownItem>
                              <CDropdownItem
                                onClick={() => enterGameAdmin(item.club_id, item.id, '/sponsors')}
                              >
                                Sponsors
                              </CDropdownItem>
                              <CDropdownDivider />
                            </CDropdownMenu>
                          </CDropdown>
                        </td>
                      ),
                    }}
                    items={users?.data}
                    itemsPerPage={itemsPerPage}
                    itemsPerPageSelect
                    loading={loading}
                    pagination={{ external: true }}
                    paginationProps={{
                      activePage: activePage,
                      pages: Math.ceil(users?.total / itemsPerPage) || 1,
                    }}
                    tableProps={{ hover: true, responsive: true }}
                    onActivePageChange={(activePage) => setActivePage(activePage)}
                    onColumnFilterChange={(filter) => {
                      setActivePage(1)
                      setColumnFilter(filter)
                    }}
                    onItemsPerPageChange={(itemsPerPage) => {
                      setActivePage(1)
                      setItemsPerPage(itemsPerPage)
                    }}
                    onSorterChange={(sorter) => setColumnSorter(sorter)}
                  />
                </CCardBody>
              </CCard>
            </CCol>
          </CRow>
        </>
      )}

      {adminDetails?.user_role_id === 1 && (
        <CRow className="admin-user-list">
          <CCol xs={12} sm={12} lg={12}>
            <CCard className="user-card">
              <CCardHeader>
                <strong>User</strong>
              </CCardHeader>
              <CCardBody>
                <AdminUserList />
              </CCardBody>
            </CCard>
          </CCol>
        </CRow>
      )}

      <GameStatusModal
        visible={visible}
        setVisible={setVisible}
        gameStatus={gameStatus}
        setGameStatus={setGameStatus}
        userId={userId}
        setUsers={setUsers}
      />
      <TransferAdminModal
        transferVisible={transferVisible}
        setTransferVisible={setTransferVisible}
        userId={userId}
      />
      <PageInfoModal
        infoPageModal={infoPageModal}
        setInfoPageModal={setInfoPageModal}
        infoText={infoText}
      />
    </>
  )
}

export default GameAccount
